import React from "react";

export interface SelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: (React.OptionHTMLAttributes<HTMLOptionElement> & {
    value: string;
    label: string;
  })[];
  ref?: any;
  placeholder?: string;
}

const Select: React.FC<SelectProps> = React.forwardRef(
  ({ options, className, ...rest }, ref: React.Ref<HTMLSelectElement>) => {
    const classNamePrefix = className || "unchained-form-select";

    return (
      <div className="form-field-input-wrapper">
        <select
          key={rest.name}
          className={`form-field-select ${classNamePrefix}`}
          ref={ref}
          {...rest}
        >
          {options.map(({ value, label, ...optionRest }, i) => (
            <option
              {...optionRest}
              key={`${value}-${i}`}
              value={value}
              className={`${classNamePrefix}__option`}
            >
              {label}
            </option>
          ))}
        </select>
      </div>
    );
  },
);

Select.displayName = "Select";

export default Select;
